import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./views/dashboard/Home.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard', active: true }
            ],
            pageTitle: 'Dashboard'
          } 
        },
        {
          path: '/dashboard/account',
          name: 'account',
          component: () => import('./views/dashboard/Account.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard', active: true }
            ],
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/dashboard/analytic',
          name: 'analytic',
          component: () => import('./views/dashboard/Analytic.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard', active: true }
            ],
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/dashboard/covid',
          name: 'covid',
          component: () => import('./views/dashboard/Covid.vue')

        },
        {
          path: '/dashboard/crypto',
          name: 'crypto',
          component: () => import('./views/dashboard/Crypto.vue')

        },
        {
          path: '/dashboard/ecommerce',
          name: 'ecommerce',
          component: () => import('./views/dashboard/Ecommerce.vue')

        },
        {
          path: '/home/secondlevel/thirdlevel',
          name: 'menu-secondlevel',
          component: () => import('./views/Page.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Second Level' },
              { title: 'Third Level' },
              { title: 'Forth Level', active: true },
            ],
            pageTitle: 'Forth Level'
          }
        }

      ],
    },
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/apps/calendar',
          name: 'Calendar',
          component: () => import('./views/apps/Calendar.vue'),
          meta: {
            breadcrumb: [
              { title: 'Apps', url: '/' },
              { title: 'Calendar', active: true }
            ],
            pageTitle: 'Calendar'
          }
        },
        {
          path: '/apps/chats',
          name: 'Chats',
          component: () => import('./views/apps/Chat.vue'),
          meta: {
            breadcrumb: [
              { title: 'Apps', url: '/' },
              { title: 'Chats', active: true }
            ],
            pageTitle: 'Chats'
          }
        },
        {
          path: '/apps/todo',
          name: 'To Do',
          component: () => import('./views/apps/Todo.vue'),
          meta: {
            breadcrumb: [
              { title: 'Apps', url: '/' },
              { title: 'To Do', active: true }
            ],
            pageTitle: 'To Do'
          }
        },
        {
          path: '/apps/mailapp',
          name: 'Mail App',
          component: () => import('./views/apps/Mail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Apps', url: '/' },
              { title: 'Mail', active: true }
            ],
            pageTitle: 'Mail'
          }
        },
        {
          path: '/charts/apex',
          name: 'Apex Chart',
          component: () => import('./views/chart/Apex.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Apex Chart', active: true }
            ],
            pageTitle: 'Apex Chart'
          }
        },
        {
          path: '/charts/chartsjs/bar',
          name: 'Chartjs Chart',
          component: () => import('./views/chart/chartjs/Bar.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Chartjs Chart', active: true }
            ],
            pageTitle: 'Chartjs Chart'
          }
        },
        {
          path: '/charts/chartsjs/line',
          name: 'Chartjs Line Chart',
          component: () => import('./views/chart/chartjs/Line.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Chartjs Line Chart', active: true }
            ],
            pageTitle: 'Chartjs Line Chart'
          }
        },
        {
          path: '/charts/chartsjs/area',
          name: 'Chartjs Area Chart',
          component: () => import('./views/chart/chartjs/Area.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Chartjs Area Chart', active: true }
            ],
            pageTitle: 'Chartjs Area Chart'
          }
        },
        {
          path: '/charts/chartsjs/others',
          name: 'Chartjs',
          component: () => import('./views/chart/chartjs/Others.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Chartjs', active: true }
            ],
            pageTitle: 'Chartjs'
          }
        },
        {
          path: '/charts/chartsjs/linear',
          name: 'linearChartjs',
          component: () => import('./views/chart/chartjs/Linear.vue'),
          meta: {
            breadcrumb: [
              { title: 'Chart', url: '/' },
              { title: 'Chartjs', active: true }
            ],
            pageTitle: 'Chartjs'
          }
        },
        {
          path: '/charts/knob-chart',
          name: 'Knob Chart                ',
          component: () => import('./views/chart/Knobchart.vue'),
          meta: {
            breadcrumb: [
              { title: 'Knob Chart', url: '/' },
              { title: 'Knob Chart', active: true }
            ],
            pageTitle: 'Knob Chart'
          }
        },        
        {
          path: '/charts/google',
          name: 'Google Chart',
          component: () => import('./views/chart/Google.vue'),
          meta: {
            breadcrumb: [
              { title: 'Google Chart', url: '/' },
              { title: 'Google Chart', active: true }
            ],
            pageTitle: 'Google Chart'
          }
        },
        {
          path: '/form/basic',
          name: 'Basic Form',
          component: () => import('./views/form/Basic.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Basic Form', active: true }
            ],
            pageTitle: 'Basic Form'
          }
        },
        {
          path: '/form/layout',
          name: 'Layout Form',
          component: () => import('./views/form/Layout.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Layout Form', active: true }
            ],
            pageTitle: 'Layout Form'
          }
        },
        {
          path: '/form/validation',
          name: 'Validation Form',
          component: () => import('./views/form/Validation.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Validation Form', active: true }
            ],
            pageTitle: 'Validation Form'
          }
        },
        {
          path: '/form/elements/switch',
          name: 'Switch Element',
          component: () => import('./views/form/Switch.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Elemenets', active: true }
            ],
            pageTitle: 'Elemenets'
          }
        },
        {
          path: '/form/elements/checkbox',
          name: 'Checkbox Element',
          component: () => import('./views/form/Checkbox.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Elemenets', active: true }
            ],
            pageTitle: 'Elemenets'
          }
        },
        {
          path: '/form/elements/radio',
          name: 'Radio Element',
          component: () => import('./views/form/Radio.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Elemenets', active: true }
            ],
            pageTitle: 'Elemenets'
          }
        },
        {
          path: '/form/elements/input',
          name: 'Input Element',
          component: () => import('./views/form/Input.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Elemenets', active: true }
            ],
            pageTitle: 'Elemenets'
          }
        },
        {
          path: '/form/wizard',
          name: 'Wizard Form',
          component: () => import('./views/form/Wizard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Form', url: '/' },
              { title: 'Wizard', active: true }
            ],
            pageTitle: 'Wizard'
          }
        },
        {
          path: '/tables/basic',
          name: 'Basic Table',
          component: () => import('./views/tables/Basic.vue'),
          meta: {
            breadcrumb: [
              { title: 'Tables', url: '/' },
              { title: 'Basic', active: true }
            ],
            pageTitle: 'Basic Table'
          }
        },
        {
          path: '/tables/advance',
          name: 'Advance Table',
          component: () => import('./views/tables/Advance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Tables', url: '/' },
              { title: 'Advance', active: true }
            ],
            pageTitle: 'Advance Table'
          }
        },
        {
          path: '/pages/404-menu',
          name: '404 Page',
          component: () => import('./views/pages/404-menu.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: '404', active: true }
            ],
            pageTitle: '404 Page'
          }
        },
        {
          path: '/pages/blank',
          name: 'Blank Page',
          component: () => import('./views/pages/Blank.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: 'Blank Page', active: true }
            ],
            pageTitle: 'Blank Page'
          }
        },
        {
          path: '/pages/gallery',
          name: 'Gallery Page',
          component: () => import('./views/pages/Gallery.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: 'Gallery Page', active: true }
            ],
            pageTitle: 'Gallery Page'
          }
        },
        {
          path: '/pages/pricing',
          name: 'Pricing Page',
          component: () => import('./views/pages/Pricing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: 'Pricing Page', active: true }
            ],
            pageTitle: 'Pricing Page'
          }
        },
        {
          path: '/pages/contact',
          name: 'Contact Us',
          component: () => import('./views/pages/Contact.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: 'Contact Us', active: true }
            ],
            pageTitle: 'Conatct Us'
          }
        },
        {
          path: '/pages/map',
          name: 'Map',
          component: () => import('./views/pages/Map.vue'),
          meta: {
            breadcrumb: [
              { title: 'Pages', url: '/' },
              { title: 'Map', active: true }
            ],
            pageTitle: 'Map'
          }
        },
        {
          path: '/ui-component/elements/alerts',
          name: 'Alert',
          component: () => import('./views/ui/Alert.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Alert', active: true }
            ],
            pageTitle: 'Alert'
          }
        },
        {
          path: '/ui-component/elements/badges',
          name: 'Badges',
          component: () => import('./views/ui/Badges.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Badges', active: true }
            ],
            pageTitle: 'Badges'
          }
        },
        {
          path: '/ui-component/elements/buttons',
          name: 'Buttons',
          component: () => import('./views/ui/Buttons.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Buttons', active: true }
            ],
            pageTitle: 'Buttons'
          }
        },
        {
          path: '/ui-component/elements/cards',
          name: 'Cards',
          component: () => import('./views/ui/Cards.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Cards', active: true }
            ],
            pageTitle: 'Cards'
          }
        },
        {
          path: '/ui-component/elements/carousel',
          name: 'Carousel',
          component: () => import('./views/ui/Carousel.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Carousel', active: true }
            ],
            pageTitle: 'Carousel'
          }
        },
        {
          path: '/ui-component/elements/collapse',
          name: 'Collapse',
          component: () => import('./views/ui/Collapse.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Collapse', active: true }
            ],
            pageTitle: 'Collapse'
          }
        },
        {
          path: '/ui-component/elements/dropdowns',
          name: 'Dropdowns',
          component: () => import('./views/ui/Dropdowns.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Dropdowns', active: true }
            ],
            pageTitle: 'Dropdowns'
          }
        },
        {
          path: '/ui-component/elements/jumbotron',
          name: 'Jumbotron',
          component: () => import('./views/ui/Jumbotron.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Jumbotron', active: true }
            ],
            pageTitle: 'Jumbotron'
          }
        },
        {
          path: '/ui-component/elements/modal',
          name: 'Modal',
          component: () => import('./views/ui/Modal.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Modal', active: true }
            ],
            pageTitle: 'Modal'
          }
        },
        {
          path: '/ui-component/elements/pagination',
          name: 'Pagination',
          component: () => import('./views/ui/Pagination.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Pagination', active: true }
            ],
            pageTitle: 'Pagination'
          }
        },
        {
          path: '/ui-component/elements/popover',
          name: 'Popover & Tooltip',
          component: () => import('./views/ui/Tooltip.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Popover & Tooltip', active: true }
            ],
            pageTitle: 'Popover & Tooltip'
          }
        },
        {
          path: '/ui-component/elements/progress',
          name: 'Progress',
          component: () => import('./views/ui/Progress.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Progress', active: true }
            ],
            pageTitle: 'Progress'
          }
        },
        {
          path: '/ui-component/elements/select',
          name: 'Select',
          component: () => import('./views/ui/Select.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Select', active: true }
            ],
            pageTitle: 'Select'
          }
        },
        {
          path: '/ui-component/elements/timeline',
          name: 'Timeline',
          component: () => import('./views/ui/Timeline.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Timeline', active: true }
            ],
            pageTitle: 'Timeline'
          }
        },
        {
          path: '/ui-component/elements/toastr',
          name: 'Toastr',
          component: () => import('./views/ui/Toastr.vue'),
          meta: {
            breadcrumb: [
              { title: 'Elements', url: '/' },
              { title: 'Toastr', active: true }
            ],
            pageTitle: 'Toastr'
          }
        },
        {
          path: '/ui-component/icons/simple-line',
          name: 'Simple Line',
          component: () => import('./views/icons/Simpleline.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Simple Line', active: true }
            ],
            pageTitle: 'Simple Line'
          }
        },
        {
          path: '/ui-component/icons/ionicons',
          name: 'Ionicons',
          component: () => import('./views/icons/Ionicons.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Ionicons', active: true }
            ],
            pageTitle: 'Ionicons'
          }
        },
        {
          path: '/ui-component/icons/font-awesome',
          name: 'Font Awesome',
          component: () => import('./views/icons/Fontawesome.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Font Awesome', active: true }
            ],
            pageTitle: 'Font Awesome'
          }
        },
        {
          path: '/ui-component/icons/crypto',
          name: 'Crypto',
          component: () => import('./views/icons/Crypto.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Crypto', active: true }
            ],
            pageTitle: 'Crypto'
          }
        },
        {
          path: '/ui-component/icons/material',
          name: 'Material Icon',
          component: () => import('./views/icons/Material.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Material Icon', active: true }
            ],
            pageTitle: 'Material Icon'
          }
        },
        {
          path: '/ui-component/icons/themify',
          name: 'Themify Icon',
          component: () => import('./views/icons/Themify.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Themify Icon', active: true }
            ],
            pageTitle: 'Themify Icon'
          }
        },
        {
          path: '/ui-component/icons/weather',
          name: 'Weather Icon',
          component: () => import('./views/icons/Weather.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Weather Icon', active: true }
            ],
            pageTitle: 'Weather Icon'
          }
        },
        {
          path: '/ui-component/icons/flag',
          name: 'Flag Icon',
          component: () => import('./views/icons/Flag.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Flag Icon', active: true }
            ],
            pageTitle: 'Flag Icon'
          }
        },
        {
          path: '/ui-component/icons/icofont',
          name: 'Icofont Icon',
          component: () => import('./views/icons/Icofont.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Icofont Icon', active: true }
            ],
            pageTitle: 'Icofont Icon'
          }
        },
        {
          path: '/ui-component/icons/linear',
          name: 'Linear Icon',
          component: () => import('./views/icons/Linear.vue'),
          meta: {
            breadcrumb: [
              { title: 'Icons', url: '/' },
              { title: 'Linear Icon', active: true }
            ],
            pageTitle: 'Linear Icon'
          }
        }




      ],
    },
    {
      path: '',
      component: () => import('./layouts/nomenu/NoMenu.vue'),
      children: [
        {
          path: '/pages/lockscreen',
          name: 'Lockscreen',
          component: () => import('./views/pages/Lockscreen.vue')
        },
        {
          path: '/pages/login',
          name: 'Login',
          component: () => import('./views/pages/Login.vue')
        },
        {
          path: '/pages/register',
          name: 'Register',
          component: () => import('./views/pages/Register.vue')
        },
        {
          path: '/pages/404',
          name: '404',
          component: () => import('./views/pages/404.vue')
        },
        {
          path: '*',
          redirect: '/pages/404'
        }   
        

        
      ]
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
